import React from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import {
  menuWidthState,
} from '@atom/setting/homepageSet';
import GameUiMainNavList from './GameUiMainNavList';
import styled, { css } from 'styled-components';
import Slider from '@components/dataDisplay/slider/Slider';
import { CollectionPath } from '@typings/collections.enum';
import { useCollection } from '@nandorojo/swr-firestore';
import { IslideItem } from '@typings/setting/slideItem';
import SubMenuList from '../common/SubMenuList';
import { gameUiVisibleState } from '@atom/ui/gameUiState';
import MiniQuest from '@pages/Quest/MiniQuest/MiniQuest';
import CumuNotice from '@template/CumuNotice/CumuNotice';
import { mainHomeSettingState } from '@atom/setting/homeSettingState';
import { POSTING_NOTICE_TYPE } from '@typings/mainHome/postingNotice';
import CharacterFuncSec from '@template/CharacterPanel/CharacterFuncSec';

import Marquee from '@components/dataDisplay/slider/Marquee';
import GameUiToggleBtn from './GameUiToggleBtn';
import ServiceFooter from '../Footer/ServiceFooter';


const padding = 24;


const Container = styled.div<{ isVisible: boolean }>`
  grid-area: nav;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  gap: 12px;
  z-index: 1;
  position: fixed;
  top: 140px;
  right: ${padding}px;
  user-select: none;

  /* translateY와 translateX를 동시에 적용 */
  transform: translateX(
    ${(props) => (props.isVisible ? '0' : 'calc(100% + 50px)')}
  );
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

const NoticeBannerSec = styled.div<{ isVisible: boolean }>`
  position: fixed;
  bottom: 40px;
  display: grid;
  grid-template-rows: 32px 200px;
  gap: 12px;
  left: ${padding}px;
  z-index: 1;

  /* SliderSec 슬라이드 애니메이션 (왼쪽으로) */
  transform: translateX(
    ${(props) => (props.isVisible ? '0' : 'calc(-100% - 50px)')}
  );
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
`;

const SliderSec = styled.div`
  width: 320px;
  height: 200px;
  position: relative;
`;

const MiniQuestWrapper = styled.div<{ isVisible: boolean }>`
  width: 100%;
  position: fixed;
  top: 300px;
  width: 320px;
  left: ${padding}px;
  z-index: 1;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  /* MiniQuest 슬라이드 애니메이션 (왼쪽으로) */
  transform: ${(props) =>
    props.isVisible
      ? 'translateX(0) translateY(-50%)'
      : 'translateX(calc(-100% - 50px)) translateY(-50%)'};
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
`;

const MarqueeSec = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--subColor) 20%,
    var(--subColor) 80%,
    transparent 100%
  );
`;
function GameUINav() {
  const [isVisible, setIsVisible] = useRecoilState(gameUiVisibleState);
  const menuWidth = useRecoilValue(menuWidthState);
  const mainHomeSet = useRecoilValue(mainHomeSettingState);


  const { data: slideList } = useCollection<IslideItem>(
    `${CollectionPath.SLIDE}`,
    { listen: true, orderBy: ['order', 'asc'] },
  );


  return (
    <>
      {/* 재화/캐릭터버튼 등 */}
      <CharacterFuncSec />
      {/* 토글 버튼 */}
      <GameUiToggleBtn />

      <NoticeBannerSec isVisible={isVisible}>
        {/* 마퀴텍스트 */}
        <MarqueeSec>
          <Marquee speed={mainHomeSet?.marqueeTextSpeed || 30}>
            {mainHomeSet?.marqueeText}
          </Marquee>
        </MarqueeSec>
        {/* 슬라이더 섹션 */}
        <SliderSec onClick={(e) => e.preventDefault()}>
          <Slider list={slideList || []} />
        </SliderSec>
      </NoticeBannerSec>

      <MiniQuestWrapper isVisible={isVisible}>
        <CumuNotice type={mainHomeSet?.postingNoticeType || POSTING_NOTICE_TYPE.DEFAULT} />
        <MiniQuest padding={padding} />
      </MiniQuestWrapper>


      {/* 네비게이션 리스트 - GameUI Grid 시스템 사용 */}
      <Container
        isVisible={isVisible}
        style={{
          width: menuWidth || '220px',
        }}
      >
        <GameUiMainNavList containerMaxWidth={menuWidth} />
      </Container>

      {/* 서브 메뉴는 별도로 렌더링 (기존 NavList 사용) */}
      <SubMenuList isVisible={isVisible} />
    </>
  );
}

export default GameUINav;
